import { ref, computed, type Ref } from 'vue'

type Callback = () => void

function useTimer(t: number, callback?: Callback) {
    const startTime: Ref<number| null> = ref(null)
    const time: Ref<number> = ref(0)
    const maxTime: Ref<number> = ref(t)
    let interval: number

    const timeout = () => {
        clearInterval(interval)
        time.value = maxTime.value
        if (callback) callback()
    }

    const updateTime = () => {
        const now = new Date().getTime()
        time.value = Math.floor((now - (startTime.value as number)) / 1000)
        if (time.value >= maxTime.value) {
            timeout()
        }
    }

    const startTimer = () => {
        time.value = 0
        startTime.value = new Date().getTime()
        interval = window.setInterval(() => {
            updateTime()
        }, 500)
    }

    const stopTimer = () => {
        clearInterval(interval)
    }

    const resetTimer = () => {
        stopTimer()
        time.value = 0
        startTime.value = null
    }

    const timeLeft = computed(() => maxTime.value - (time.value as number))

    const seconds2readable = (sec: number) => {
        const minutes = Math.floor(sec / 60)
        const seconds = sec - 60 * minutes

        const addZero = (digit: number) => {
            if (digit > 9) return digit
            return `0${digit}`
        }

        return `${addZero(minutes)}:${addZero(seconds)}`
    }

    return {
        time,
        timeLeft,
        startTimer,
        resetTimer,
        seconds2readable,
        stopTimer,
    }
}


export default useTimer
